export const MLFLOW_INTERNAL_PREFIX = 'mlflow.';




// WEBPACK FOOTER //
// ./src/utils/TagUtils.js